import { render } from "./InvoiceView.vue?vue&type=template&id=7e96daa4&scoped=true"
import script from "./InvoiceView.vue?vue&type=script&lang=js"
export * from "./InvoiceView.vue?vue&type=script&lang=js"

import "./InvoiceView.vue?vue&type=style&index=0&id=7e96daa4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7e96daa4"

export default script